import CaracteristiqueFormController from './caracteristique.form.controller';

export default {
    template: require('./caracteristique.form.tpl.html'),
    controller: CaracteristiqueFormController,
    bindings: {}
};
